import { Component, Host, h, Prop } from "@stencil/core";
import { ProductAvailabilityStatus } from "../../engagement/bcp-status/bcp-status";
import state from "@stores/price.store";

@Component({
  tag: "bcp-stock",
  styleUrl: "bcp-stock.scss",
  shadow: true,
})
export class Stock {
  @Prop() productId!: string;
  @Prop() fallbackStatusCode: string;
  @Prop() fallbackStatusText: string;

  @Prop() inStockStatusText: string;
  @Prop() lowStockStatusText: string;
  @Prop() outOfStockStatusText: string;
  @Prop() noStockText: string;

  availabilityStatus = {
    inStock: () => this.inStockStatusText,
    lowStock: () => this.lowStockStatusText,
    outOfStock: () => this.outOfStockStatusText,
  };

  render() {
    const code = state.get("stocks")?.get(this.productId)?.syncStock
      ?.stockLevelStatus?.code;
    const timeout = state.get("timeoutStocks");
    const loading = state.get("loadingStocks");
    const stocksFailed = state.get("stocksFailed");

    return (
      <Host>
        {code && (
          <ProductAvailabilityStatus
            statusCode={code}
            statusText={this.availabilityStatus[code]?.call()}
          />
        )}
        {timeout && (
          <ProductAvailabilityStatus
            statusCode={this.fallbackStatusCode}
            statusText={this.fallbackStatusText}
          />
        )}
        {stocksFailed && this.outOfStockStatusText && (
          <ProductAvailabilityStatus
            statusCode="outOfStock"
            statusText={this.outOfStockStatusText}
          />
        )}
        {!code && !this.fallbackStatusCode && this.noStockText && (
          <ProductAvailabilityStatus
            statusCode="noInfo"
            statusText={this.noStockText}
          />
        )}
        {loading && <span>&nbsp;</span>}
      </Host>
    );
  }
}
